import React from 'react';

const CollapseIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 6L4.57333 2.42667C4.59652 2.40345 4.62406 2.38502 4.65437 2.37245C4.68469 2.35988 4.71718 2.35342 4.75 2.35342C4.78282 2.35342 4.81531 2.35988 4.84563 2.37245C4.87594 2.38502 4.90348 2.40345 4.92667 2.42667L8.5 6"
      stroke="currentColor"
      strokeOpacity="0.75"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CollapseIcon;
